class HpIngredientsSection extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.hp-ingredients__tab'));
    this.panels = Array.from(this.querySelectorAll('.hp-ingredients__panel'));
    this.modalOverlay = this.querySelector('.hp-ingredients__modal-overlay');
    this.modalTabs = Array.from(this.querySelectorAll('.hp-ingredients__modal-tab'));
    this.modalPanels = Array.from(this.querySelectorAll('.hp-ingredients__modal-panel'));
    this.closeBtn = this.querySelector('.hp-ingredients__modal-close');
    this.seeLinks = Array.from(this.querySelectorAll('.hp-ingredients__see-link'));

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.switchTab(i));
    });

    this.modalTabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.switchModalTab(i));
    });

    this.seeLinks.forEach((link) => {
      link.addEventListener('click', () => this.openModal());
    });

    this.closeBtn?.addEventListener('click', () => this.closeModal());

    this.modalOverlay?.addEventListener('click', (e) => {
      if (e.target === this.modalOverlay) this.closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeModal();
    });
  }

  switchTab(index) {
    this.tabs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    this.panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
    this.switchModalTab(index);
  }

  switchModalTab(index) {
    this.modalTabs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    this.modalPanels.forEach((p, i) => p.classList.toggle('is-active', i === index));
  }

  openModal() {
    this.modalOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    const activeIndex = this.tabs.findIndex(t => t.classList.contains('is-active'));
    if (activeIndex >= 0) this.switchModalTab(activeIndex);
  }

  closeModal() {
    this.modalOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

customElements.define('hp-ingredients-section', HpIngredientsSection);
